import Vue from "vue";
import ECharts from 'vue-echarts';

Vue.use(ECharts);

Vue.component("v-chart", ECharts);
